module.exports = __webpack_public_path__ + "static/img/noCartcc4d12d.png";